import { Provider } from "react-redux";
import React from 'react';
import store from "./redux/store";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/custom.css';
import './assets/css/main.css';
import 'antd/dist/antd.css';
import 'react-spring-bottom-sheet/dist/style.css'

// import './assets/css/register.css'
// import 'react-spring-bottom-sheet/dist/style.css'
// import 'antd/dist/antd.css';
// import 'react-phone-input-2/lib/style.css'

const Root = ({ children, initialState = {} }) => (
    <React.Fragment>
        <Provider store={store(initialState)}>
            {children}

        </Provider>
    </React.Fragment>
);


export default Root;
